import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";

const QUERY_PRODUCT = gql`
  query productByCode($code: String!) {
    productByCode(code: $code) {
      id
      picture
    }
  }
`;

const QUERY_PRODUCT_OPTION = gql`
  query displayProductOption($id: Int!, $ship: Boolean = false) {
    displayProductOption(id: $id, mustIncludeSkuId: true, ship: $ship) {
      remoteStock
      remoteDuration {
        from
        to
      }
      colorList {
        value
        sizeList {
          value
          skuId
          actualQty
        }
      }
    }
  }
`;

interface Props {
  isAdd: boolean;
  onAdd: () => void;
  onRemove: () => void;
  id: string;
  code?: string;
  color?: string;
  size?: string;
  unit?: string;
  disabled?: boolean;
  ship?: boolean;
  onChange?: any;
}

export function FieldLoginLess(props: Props) {
  const [codeinput, setCodeInput] = useState(props.code ? props.code : "");
  const [code, setCode] = useState(props.code ? props.code : "");
  const [unit, setUnit] = useState(props.unit ? props.unit : 1);
  const [id, setId] = useState<number>(0);
  const [sku, setSku] = useState(0);
  const [index, setIndex] = useState(-1);
  const [loading, setLoading] = useState(false);

  const product = useQuery(QUERY_PRODUCT, {
    skip: !code,
    variables: {
      code,
    },
    onCompleted: (res) => {
      setId(Number(res.productByCode.id));
      setIndex(-1);
      setSku(0);
    },
  });
  const option = useQuery(QUERY_PRODUCT_OPTION, {
    skip: id === 0,
    variables: {
      id,
      ship: props.ship,
    },
    onCompleted: (res) => {
      if (props.color && props.size) {
        const c = res.displayProductOption.colorList.findIndex(
          (c: any) => String(c.value).toLowerCase() === props.color?.toLowerCase(),
        );
        const s = res.displayProductOption.colorList[c].sizeList.find(
          (s: any) => String(s.value).toLowerCase() === props.size?.toLowerCase(),
        );
        setIndex(c);
        setSku(Number(s.skuId));
      }
    },
  });

  const handleKeyPress = (e: any) => {
    if (e.keyCode === 13) {
      if (codeinput) {
        setCode(codeinput);
      }
    }
  };

  const handleBlur = () => {
    if (codeinput) {
      setCode(codeinput);
    }
  };

  return (
    <tr>
      <td>
        <span id={"itemid" + props.id} style={{ display: "none" }}>
          {id}
        </span>
        <div style={{ display: "flex", alignItems: "center" }}>
          {product.data && <img src={product.data.productByCode.picture} style={{ width: 50, height: 50 }} alt="" />}
          <div>
            <input
              id={"code" + props.id}
              type="text"
              className="form-control form-control-sm form-secondary"
              placeholder="Enter product code"
              value={codeinput}
              onChange={(e) => setCodeInput(e.target.value)}
              onKeyDown={handleKeyPress}
              onBlur={handleBlur}
              disabled={props.disabled}
            />
            {option.data && (
              <small className="text-danger">
                {option.data.displayProductOption.remoteStock ? "Remote Stock" : ""}
              </small>
            )}
          </div>
        </div>
      </td>
      <td>
        {option.data && (
          <div>
            <select
              id={"color" + props.id}
              className="form-control form-control-sm form-secondary"
              value={index}
              onChange={(e) => {
                setLoading(true);
                setUnit(0);
                setIndex(Number(e.target.value));
                setTimeout(() => {
                  setLoading(false);
                }, 500);
              }}
            >
              <option value={-1}>Select Color</option>
              {option.data.displayProductOption.colorList.map((x: any, i: number) => {
                return (
                  <option key={i} value={i}>
                    {x.value}
                  </option>
                );
              })}
            </select>
          </div>
        )}
      </td>
      <td>
        {option.data && index >= 0 && (
          <select
            id={"size" + props.id}
            className="form-control form-control-sm form-secondary"
            value={sku}
            onChange={(e) => {
              setLoading(true);
              setSku(Number(e.target.value));
              setTimeout(() => {
                setLoading(false);
              }, 500);
            }}
          >
            <option value={0}>Select Size</option>
            {option.data.displayProductOption.colorList[index].sizeList.map((x: any, i: number) => {
              return (
                <option key={i} value={x.skuId}>
                  {x.value}
                </option>
              );
            })}
          </select>
        )}
      </td>
      <td>
        {!loading &&
          option.data &&
          index >= 0 &&
          sku > 0 &&
          option.data.displayProductOption.colorList[index] &&
          option.data.displayProductOption.colorList[index].sizeList &&
          option.data.displayProductOption.colorList[index].sizeList.find(
            (x: any) => Number(x.skuId) === Number(sku),
          ) &&
          option.data.displayProductOption.colorList[index].sizeList.find((x: any) => Number(x.skuId) === Number(sku))
            .actualQty}
      </td>
      <td style={{ width: 150 }}>
        {option.data && sku > 0 && (
          <input
            id={"unit" + props.id}
            type="number"
            className="form-control form-control-sm form-secondary"
            placeholder="Enter unit"
            value={unit}
            onChange={(e) => {
              setUnit(Number(e.target.value));
              if (props.onChange) {
                props.onChange({
                  skuId: sku,
                  qty: unit,
                });
              }
            }}
          />
        )}
      </td>
      <td>
        {option.data && option.data.displayProductOption.remoteStock && (
          <span>
            from {option.data.displayProductOption.remoteDuration.from | 0} to{" "}
            {option.data.displayProductOption.remoteDuration.to | 0}
          </span>
        )}
      </td>
      <td style={{ width: 20 }}>
        {props.isAdd ? (
          <span
            className="os-icon os-icon-plus-circle text-success"
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={props.onAdd}
          ></span>
        ) : (
          <span
            className="os-icon os-icon-x-circle text-danger"
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={props.onRemove}
          ></span>
        )}
      </td>
    </tr>
  );
}
